import { render, staticRenderFns } from "./customTable.vue?vue&type=template&id=62541d7a&scoped=true&"
import script from "./customTable.vue?vue&type=script&lang=js&"
export * from "./customTable.vue?vue&type=script&lang=js&"
import style0 from "./customTable.vue?vue&type=style&index=0&id=62541d7a&lang=scss&scoped=true&"
import style1 from "./customTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62541d7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62541d7a')) {
      api.createRecord('62541d7a', component.options)
    } else {
      api.reload('62541d7a', component.options)
    }
    module.hot.accept("./customTable.vue?vue&type=template&id=62541d7a&scoped=true&", function () {
      api.rerender('62541d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vab/table/customTable.vue"
export default component.exports